module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAGQCAYAAABvWArbAAAANklEQVQ4jWN48uTJfyYGBgaGUWKUGCWGLfHt2zcoi5GREYNgYmJCZiG42IiB98woMUqMEtgIAMdjCdyg+eEBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/ui/images/ui-bg_glass_75_dadada_1x400.png
// module id = 229
// module chunks = 0